import { createAppBasePath } from '@beautyburst/tokens';

/**
 * Retailer route patterns stay independent of deployment location. Apply this
 * adapter at browser boundaries only.
 */
/**
 * For a relative Vite base, the shared helper expects a directory URL whose
 * parent is the app base. Browser bundles live in `assets/`, whereas
 * `import.meta.url` names the module itself. Passing the assets directory
 * avoids mistakenly treating `/assets/` as part of the portal route base.
 */
export function createRetailerBasePath(
  viteBase = import.meta.env.BASE_URL,
  moduleUrl = import.meta.url,
) {
  return createAppBasePath(viteBase, new URL('.', moduleUrl).toString());
}

export const retailerBasePath = createRetailerBasePath();
export const retailerHref = (path: string): string => retailerBasePath.prefix(path);
export const retailerAsset = (path: string): string => retailerBasePath.asset(path);
